export default "__VITE_ASSET__BBYITzdh__"